<template>
  <div v-if="tagIds.length || hasDefaultSlot" class="sf-level remark-tags-list">
    <RemarkTag
      v-for="tag in remarkTags"
      :key="tag.id"
      :tag="tag"
      :disable-link="disableLinks"
    />
    <span class="slot-wrapper">
      <slot />
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import RemarkTag from '@app/application/communication/sections/communication/components/remarks/remark-tag.vue'
import orderBy from 'lodash/orderBy'

export default {
  components: { RemarkTag },
  props: {
    tagIds: {
      type: Array,
      required: true,
    },
    disableLinks: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['remarkTagById']),
    hasDefaultSlot() {
      const defaultSlot = this.$slots?.default
      return typeof defaultSlot === 'function'
        ? !!this.$slots?.default()
        : false
    },
    remarkTags() {
      const companyId =
        this.$store.state.companyId ||
        this.$store.getters.activeCompanyId ||
        window.Silverfin.currentCompanyId

      const clientMeetingsPreparationUrl =
        window.Silverfin.Routes.client_meetings_prepare_path(
          window.Silverfin.currentFirmId,
          companyId
        )

      const result = []
      for (const id of this.tagIds) {
        const tag = this.remarkTagById(id)
        if (tag && tag.talkingPoint) {
          result.push({ ...tag, url: clientMeetingsPreparationUrl })
        } else if (tag) {
          result.push(tag)
        }
      }
      return orderBy(result, ['talkingPoint', 'name'], ['desc', 'asc'])
    },
  },
}
</script>

<style scoped>
.remark-tags-list .slot-wrapper {
  margin-bottom: 5px;
}
</style>
